import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { Modal } from '../../../../../common/components/modal'
import { LightGreyButton } from '../../../../../theme/Forms/Buttons'
import {
  CompanySettingsConfirmationModalMessage,
  CompanySettingsModalGridContainer
} from './styles'
import { StyledButton } from '../../../../../theme/Global'

const CompanySettingsModal = ({ setCloseAction, saveAction }) => (
  <CompanySettingsModalGridContainer
    container
    spacing={32}
    direction="row"
    justify="space-between"
  >
    <Grid item xs={12}>
      <CompanySettingsConfirmationModalMessage variant="body1">
        Adjusting your Company Settings may change the data for some locations.
        Are you sure you want to make changes to your Company Settings?
      </CompanySettingsConfirmationModalMessage>
    </Grid>
    <Grid item xs={6}>
      <Typography variant="body1" align="Left">
        <StyledButton onClick={saveAction}>Confirm</StyledButton>
      </Typography>
    </Grid>
    <Grid item xs={6}>
      <Typography variant="body1" align="right">
        <LightGreyButton onClick={setCloseAction}>
          Cancel
        </LightGreyButton>
      </Typography>
    </Grid>
  </CompanySettingsModalGridContainer>
)

export const SettingsConfirmationModal = ({ open, close, save }) => (
  <Modal
    open={open}
    data-testid="company-settings-confirmation-modal"
    title=""
    component={(
      <CompanySettingsModal {...{
        setCloseAction: close,
        saveAction: save
      }}
      />
    )}
    modalCloseDispatch={close}
    isFullWidth
    maxWidth="sm"
    unsetHeight
  />
)
